import React from "react";

const FormCard = ({ icon, title, headerRight, children, className = "" }) => {
  return (
    <section className={`bg-white p-5 rounded-xl border border-slate-200 shadow-sm ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
            <span className="material-symbols-outlined text-lg">{icon}</span>
          </div>
          <h3 className="text-sm font-bold text-primary">{title}</h3>
        </div>
        {headerRight}
      </div>
      {children}
    </section>
  );
};

export default React.memo(FormCard);